@if (date !== undefined && date !== '') {
  <span translate="tdWb.pageHeader.AS_OF"></span>
}
<span id="td-wb-page-header-date"
      [innerText]="date"></span>

